// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_1ZiNb","Block":"Content__Block_tVj-c","ColLeft":"Content__ColLeft_2ME89"};